import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import {
  SmallText,
  TextLink,
  BodyBold,
} from 'ggx-componentlibrary/design/typography/typography.styles'
import CalendarIcon from 'ggx-src/van-booking/order/sidebar/order-form/summary/payment-method/assets/calendar.svg'
import {
  StyledCreditCardPayment,
  PaymentMethodTitle,
} from 'ggx-src/van-booking/order/sidebar/order-form/summary/payment-method/payment-method.component.styles'
import translate from 'ggx-src/legacy/locales/translate'

const MonthlySettlementDisplay = ({ showChargeInfo }) => {
  const [t] = useTranslation()

  return (
    <>
      <StyledCreditCardPayment style={{ padding: '10px 0' }}>
        <CalendarIcon />
        <PaymentMethodTitle>
          <BodyBold typographyStyles="mb-none">
            {t('common__monthly_settlement')}
          </BodyBold>
        </PaymentMethodTitle>
      </StyledCreditCardPayment>
      {showChargeInfo && (
        <SmallText typographyStyles="mb-none" style={{ margin: '20px -1px 0' }}>
          {translate('orders.new.basicInfo.chargeInfo')}
        </SmallText>
      )}
      <SmallText typographyStyles="mb-none" style={{ margin: '20px -1px 0' }}>
        <Trans
          i18nKey="common__text_terms&conditions"
          components={
            <TextLink
              href={t('common__link_terms&conditions')}
              target="_blank"
            />
          }
        />
      </SmallText>
    </>
  )
}

export { MonthlySettlementDisplay }
